// Klíče textů metodiky pro jméno typu (DES-002 §3, CR-007): podstatné jméno pólu, jeho rod
// a přídavné jméno v tom rodě. Jedna definice pro web (Skica, mezivýsledky) i API (náhled při
// sdílení, REQ-024).

export interface TextValue {
  readonly value: string;
}

export type TextMap = Readonly<Record<string, TextValue | undefined>>;

export function nounKey(noun: string): string {
  return `type.noun_word.${noun}`;
}

/** Klíč přídavného jména v rodě podstatného jména. Bez textu rodu `null`. */
export function adjectiveKey(texts: TextMap, noun: string, adjective: string): string | null {
  const gender = texts[`type.noun_gender.${noun}`]?.value.trim();
  return gender === undefined || gender === "" ? null : `type.adj_word.${adjective}.${gender}`;
}

/** Jméno typu jako text (přídavné jméno a podstatné jméno), chybějící slovo vynechá. */
export function typeNameText(texts: TextMap, noun: string, adjective: string): string {
  const adj = adjectiveKey(texts, noun, adjective);
  return [adj === null ? undefined : texts[adj]?.value, texts[nounKey(noun)]?.value].filter((w) => w !== undefined && w !== "").join(" ");
}
